/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-BasicSpinnersExample .ms-Spinner{display:inline-block;margin:10px 0}"}]);
/* tslint:enable */